export { LY_UPLOAD_CONTROL_VALUE_ACCESSOR, LyUploadFiles, LyUploadFilesModule } from './upload-files';



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/upload-files/index.js
// module id = 1365
// module chunks = 31